import z from "zod";
import { StandardTest, TestRequest } from "@/api/williams/tests";
import { UserSchema } from "../users";

export const StandardTestSchema = z
  .object({
    recordId: z.string(),
    templateNumber: z.string(),
  })
  .transform((data) => data as StandardTest);

export const TestRequestSchema = z
  .object({
    projectNumber: z.string().nullish(),
    projectName: z.string().nullish(),
    projectDescription: z.string().nullish(),
    contractor: z.string().nullish(),
    wps: z.string().nullish(),
    processes: z.string().nullish(),
    materials: z.string().nullish(),
    thickness: z.string().nullish(),
    diameter: z.string().nullish(),
    position: z.string().nullish(),
    progression: z.string().nullish(),
    weldType: z.string().nullish(),
    weldingSpecialist: UserSchema,
    phoneNumber: z.string().nullish(),
    otherNeeds: z.string().nullish(),
  })
  .transform((data) => data as TestRequest);
